import gql from 'graphql-tag';

const MUTATION_MARK_REFERRAL_COMPLETE = gql`
	mutation MarkReferralComplete($id: String!) {
		markReferralComplete(id: $id)
	}
`;

export default MUTATION_MARK_REFERRAL_COMPLETE;